import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import VendorPage from "./pages/VendorPage";
import VendorDetailsPage from "./pages/VendorDetailsPage";
import VendorTwoPage from "./pages/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
import BecomeSellerPage from "./pages/BecomeSellerPage";
import WishlistPage from "./pages/WishlistPage";
import { useCurrenciesStore } from "./stores/currenciesStore";
import { useEffect, useState } from "react";
import { useCategoriesStore } from "./stores/categoriesStore";
import { useSettingsStore } from "./stores/settingsStore";
import { useCart } from "./stores/cartStore";
import OrderSuccess from "./pages/OrderSuccess";
import OrderInfo from "./pages/OrderInfo";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ProfilePage from "./pages/ProfilePage";
import OrdersPage from "./pages/OrdersPage";
import ShippingPolicyPage from "./pages/ShippingPolicyPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import { ensureCsrfToken } from "./utils/axiosInstance";

function App() {

  const fetchCurrencies = useCurrenciesStore((state) => state.fetchCurrencies)

  const fetchCategories = useCategoriesStore((state) => state.fetchCategories)

  const fetchSettings = useSettingsStore((state) => state.fetchSettings)

  // Get cart functions but don't initialize yet
  const { fetchCartItems, fetchBestDiscount } = useCart()

  useEffect(() => {
    // First ensure we have a CSRF token, then fetch all initial data
    const initializeApp = async () => {
      // Get CSRF token first to ensure it's available for all subsequent requests
      await ensureCsrfToken();
      
      // Then fetch all initial app data
      fetchCurrencies();
      fetchCategories();
      fetchSettings();
      
      // Initialize cart after CSRF token is fetched
      try {
        await fetchCartItems();
        await fetchBestDiscount();
      } catch (error) {
        console.error('Failed to fetch initial cart items:', error);
      }
    };
    
    initializeApp();
  }, []) // Empty dependency array means this runs once when component mounts

  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />

      <Routes>
        <Route exact path='/' element={<HomePageTwo />} />
        <Route exact path='/index-two' element={<HomePageTwo />} />
        {/* <Route exact path='/index-three' element={<HomePageThree />} /> */}
        <Route exact path='/shop' element={<ShopPage />} />
        {/* <Route
          exact
          path='/product-details'
          element={<ProductDetailsPageOne />}
        /> */}
        <Route path='/products'>
          <Route
            exact
            path=':productSlug'
            element={<ProductDetailsPageTwo />}
          />
        </Route>
        <Route exact path='/cart' element={<CartPage />} />
        <Route exact path='/checkout' element={<CheckoutPage />} />
        {/* <Route exact path='/become-seller' element={<BecomeSellerPage />} /> */}
        {/* <Route exact path='/wishlist' element={<WishlistPage />} /> */}
        <Route exact path='/account' element={<LoginPage />} />
        {/* <Route exact path='/blog' element={<BlogPage />} /> */}
        {/* <Route exact path='/blog-details' element={<BlogDetailsPage />} /> */}
        {/* <Route exact path='/contact' element={<ContactPage />} /> */}
        {/* <Route exact path='/vendor' element={<VendorPage />} /> */}
        {/* <Route exact path='/vendor-details' element={<VendorDetailsPage />} /> */}
        {/* <Route exact path='/vendor-two' element={<VendorTwoPage />} /> */}
        {/* <Route
          exact
          path='/vendor-two-details'
          element={<VendorTwoDetailsPage />}
        /> */}
        <Route exact path='/order-success' element={<OrderSuccess />} />
        <Route exact path='/order-info' element={<OrderInfo />} />
        <Route exact path='/login' element={<LoginPage />} />
        <Route exact path='/register' element={<RegisterPage />} />
        <Route exact path='/profile' element={<ProfilePage />} />
        <Route exact path='/orders' element={<OrdersPage />} />
        <Route exact path='/shipping-policy' element={<ShippingPolicyPage />} />
        <Route exact path='/privacy-policy' element={<PrivacyPolicyPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
